import { Drawer } from '@material-ui/core';
import * as React from 'react';
import { Button } from '../../../components/button/Button';
import { DataGroup } from '../../../components/data-group/DataGroup';
import { DataGroupPoint } from '../../../components/data-group/DataGroupPoint';
import { FlyoutFooter } from '../../../components/flyout-components/FlyoutFooter';
import { PageHeading } from '../../../components/page-components/_index';
import { OrderInvoiceStatusMetadata } from '../../../models/ordering/enums/order-invoice-status';
import { OrderProductionStatusMetadata } from '../../../models/ordering/enums/order-production-status';
import { OrderShipmentStatusMetadata } from '../../../models/ordering/enums/order-shipment-status';
import { OrderStatus, OrderStatusMetadata } from '../../../models/ordering/enums/order-status';
import { OrderType, OrderTypeMetadata } from '../../../models/ordering/enums/order-type';
import { AppUtils } from '../../../utils/app-utils';
import { toLongDateTime } from '../../../utils/date-utils';
import { OrderHistoryRow } from './OrderHistoryRow';
import { PendingReason } from '../../../models/ordering/enums/pending-reason';

const getStatusText = (metadata: { [status: string]: { display: string } }, status: number) => {
    return metadata[status]?.display ?? '';
};

interface IProps {
    isOpen: boolean;
    onClose: any;
    orderObj: any;
    orderHistory: any;
}

export const OrderDetailFlyout = (props : IProps) => {

    const [selectedTabIdx, setSelectedTabIdx]   = React.useState(0);
        
    React.useEffect(() => {
        if (props.isOpen) {
            setSelectedTabIdx(0);
        }
    }, [props.isOpen]);

    const getPendingReasonText = (pendingReason: PendingReason) => {
        const reasons: string[] = [];

        if (pendingReason & PendingReason.CreditHold) {
            reasons.push('Credit Hold');
        }
        if (pendingReason & PendingReason.EngineeringReview) {
            reasons.push('Engineering Review');
        }
        if (pendingReason & PendingReason.WindLoadReview) {
            reasons.push('Wind Load Review');
        }
        if (pendingReason & PendingReason.CustomerServiceReview) {
            reasons.push('Customer Service Review');
        }
        if (pendingReason & PendingReason.AddressReview) {
            reasons.push('Address Review');
        }

        return reasons.length ? `Pending (${reasons.join(', ')})` : 'Pending';
    };

    const getOrderStatus = () => {
        const status = props.orderObj.status as OrderStatus;
        if (status === OrderStatus.Pending) {
            // say what the order is waiting on
            const pendingReason = props.orderObj.pendingReason as PendingReason;
            return getPendingReasonText(pendingReason);
        }

        return getStatusText(OrderStatusMetadata, status);
    };

    const closeFlyout = () => {
        props.onClose();
    };

    /**
     * Switch UI tabs between details and history
     */
        const onTabChange = (e: any, val: any) => {
        setSelectedTabIdx(val);
    };

    return (
        !AppUtils.IsEmpty(props.orderObj)        
            ? <Drawer
                anchor="right"
                onClose={ closeFlyout }
                open={props.isOpen}>
                <div className="stop-action-drawer large backorder-status-flyout">
                    <div className="row">
                        <div className="col">
                            <h1>Order Details</h1>
                        </div>
                    </div>
                        
                    <div className="row order-body">
                        <div className="col">
                            <DataGroup title="">
                                <DataGroupPoint 
                                    label="Order ID" 
                                    value={ props.orderObj.id } />
                                <DataGroupPoint 
                                    label="Description" 
                                    value={ props.orderObj.description } />
                                <DataGroupPoint 
                                    label="Service Center" 
                                    value={ props.orderObj.serviceCenterId } />
                                <DataGroupPoint 
                                    label="Billing Only?" 
                                    value={ props.orderObj.isBillingOnly ? "True" : "False" } />
                                <DataGroupPoint 
                                    label="Status" 
                                    value={ getOrderStatus() } />
                                <DataGroupPoint 
                                    label="Production Status" 
                                    value={ getStatusText(OrderProductionStatusMetadata, props.orderObj.orderProductionStatus) } />
                                <DataGroupPoint 
                                    label="Shipment Status" 
                                    value={ getStatusText(OrderShipmentStatusMetadata, props.orderObj.orderShipmentStatus) } />
                                <DataGroupPoint 
                                    label="Invoice Status" 
                                    value={ getStatusText(OrderInvoiceStatusMetadata, props.orderObj.orderInvoiceStatus) } />
                                <DataGroupPoint 
                                    label="Type" 
                                    value={ OrderTypeMetadata[(props.orderObj.type as OrderType)].display } />
                                <DataGroupPoint 
                                    label="Created On" 
                                    value={ toLongDateTime(props.orderObj.createdOn) } />
                                <DataGroupPoint 
                                    label="Last Modified" 
                                    value={ toLongDateTime(props.orderObj.lastModified) } />
                            </DataGroup>
                        </div>
                    </div>
                    
                    <PageHeading 
                        title=""
                        useTabs={true}
                        tabLabels={[ 'Order View', 'History' ]}
                        onTabChange={ onTabChange }
                        selectedTab={ selectedTabIdx } />

                    {
                        selectedTabIdx === 0 
                            ? <div className="row order-body">
                                <div className="col">
                                <pre 
                                    dangerouslySetInnerHTML={{
                                        __html: AppUtils.colorizeJson(
                                            props.orderObj
                                        )
                                    }}
                                />
                                </div>
                            </div>
                            : null
                    }
                    {
                        selectedTabIdx === 1 
                            ? <div className="row order-body">
                                <div className="col">
                                    {
                                        props.orderHistory && props.orderHistory.events && props.orderHistory.events.length
                                            ? props.orderHistory.events.map((itm: any, idx : number) => 
                                                <OrderHistoryRow key={ idx } history={ itm } index={ idx } />
                                            )
                                            : "No History to Show"
                                    }
                                </div>
                            </div>
                            : null
                    }

                    <FlyoutFooter>
                        <div className="row">
                            <div className="col">                            
                                <Button
                                    text="Close"
                                    classes="action"
                                    testID="close-setdate-run-flyout"
                                    onBtnClick={ closeFlyout } />
                            </div>
                        </div>
                    </FlyoutFooter> 
                    
                </div>
            </Drawer>
            : null
    );
};
